<template>
  <li
    :class="{'active' : isActiveLnb }">
    <router-link :to="{name : lnbMenu.routerPath }" class="link_lnb">
      <span class="txt_menu">{{ lnbMenu.title }}</span>
    </router-link>
  </li>
</template>

<script>
import { wordToUpperCase } from '@lemontree-ai/lemontree-admin-common-front/utils/stringUtils'
export default {
  name:'LnbItem',
  props:{
    lnbMenu: Object,
  },
  computed:{
    isActiveLnb(){
      return this.$route.meta.lnbMenuData && this.$route.meta.lnbMenuData.id === wordToUpperCase(this.lnbMenu.id);
    },
  },
}
</script>
<style lang="scss" scoped>

.snb_lemontree .list_snb .link_lnb{display:block;margin-top:4px;padding:7px 37px 3px;border-radius:$CONTENT_RADIUS;font-weight:500;font-size:14px;line-height:30px;color:rgba($ACTIVE_TEXT,.6);transition:background-color 0.1s}
.snb_lemontree .list_snb .link_lnb:hover{background-color:rgba($SECONDARY_COLOR,.08);color:$ACTIVE_TEXT}
.snb_lemontree .list_snb .active > .link_lnb{background-color:rgba($SECONDARY_COLOR,.08);color:$ACTIVE_TEXT}

@media (prefers-color-scheme: dark) {
  .snb_lemontree .list_snb .link_lnb{color:rgba($ACTIVE_TEXT_DARK,.8)}
  .snb_lemontree .list_snb .link_lnb:hover{background-color:rgba($SECONDARY_DARK_COLOR,.08);color:$ACTIVE_TEXT_DARK}
  .snb_lemontree .list_snb .active > .link_lnb{background-color:rgba($SECONDARY_DARK_COLOR,.08);color:$ACTIVE_TEXT_DARK}
}
</style>